var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('router-link',{staticClass:"d-inline-block",attrs:{"to":"/"}},[_c('img',{attrs:{"loading":"lazy","src":require("@/assets/images/iland-logo.png"),"alt":"iland logo"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }